class CartAddonProducts extends HTMLElement {
    constructor() {
        super();
        this.buttonText = 'Add to Cart';
        this.isInitialized = false;
    }

    connectedCallback() {
        this.retryCount = 0;
        this.maxRetries = 5;
        this.initializeWithRetry();
    }

    initializeWithRetry() {
        const productContainers = this.querySelectorAll('.eam-cc-addon-product');
        
        if (productContainers.length === 0 && this.retryCount < this.maxRetries) {
            this.retryCount++;
            setTimeout(() => {
                this.initializeWithRetry();
            }, 100 * this.retryCount);
            return;
        }

        this.setupVariantSelection();
    }

    disconnectedCallback() {
        this.isInitialized = false;
    }

    setupVariantSelection() {
        if (this.isInitialized) {
            return;
        }

        const productContainers = this.querySelectorAll('.eam-cc-addon-product');
        
        productContainers.forEach(container => {
            const selects = container.querySelectorAll('.eam-cc-addon-variant-select');
            
            selects.forEach(select => {
                select.addEventListener('change', () => {
                    this.updateVariantSelection(container);
                });
            });
        });

        this.isInitialized = true;
    }

    updateVariantSelection(productContainer) {
        const selects = productContainer.querySelectorAll('.eam-cc-addon-variant-select');
        if (selects.length === 0) return;

        const productId = selects[0].dataset.productId;
        
        let productData = this.getProductData(productId, productContainer);
        if (!productData) {
            return;
        }

        const selectedOptions = [];
        let allSelected = true;

        productData.options.forEach((optionName, index) => {
            const select = Array.from(selects).find(s => s.dataset.optionName === optionName);
            if (select && select.value) {
                selectedOptions[index] = select.value;
            } else {
                allSelected = false;
                selectedOptions[index] = null;
            }
        });

        const variantIdInput = productContainer.querySelector('.eam-cc-addon-variant-id');
        const addButton = productContainer.querySelector('.eam-cc-addon-product-button');

        if (!allSelected) {
            if (variantIdInput) {
                variantIdInput.value = '';
                variantIdInput.disabled = true;
            }
            if (addButton) {
                addButton.disabled = true;
                addButton.textContent = this.buttonText;
            }
            return;
        }

        const matchingVariant = productData.variants.find(variant => {
            return variant.options.every((option, index) => option === selectedOptions[index]);
        });

        if (matchingVariant) {
            if (variantIdInput) {
                variantIdInput.value = matchingVariant.id;
                variantIdInput.disabled = false;
            }

            if (addButton) {
                if (matchingVariant.available) {
                    addButton.disabled = false;
                    addButton.removeAttribute('disabled');
                    addButton.textContent = this.buttonText;
                } else {
                    addButton.disabled = true;
                    addButton.textContent = 'Out Of Stock';
                }
            }
        } else {
            if (variantIdInput) {
                variantIdInput.value = '';
                variantIdInput.disabled = true;
            }
            if (addButton) {
                addButton.disabled = true;
                addButton.textContent = 'Unavailable';
            }
        }
    }

    getProductData(productId, productContainer) {
        if (window.cartAddonVariants?.[productId]) {
            return window.cartAddonVariants[productId];
        }

        const scriptTag = productContainer.querySelector('script');
        if (scriptTag) {
            try {
                eval(scriptTag.textContent);
                if (window.cartAddonVariants?.[productId]) {
                    return window.cartAddonVariants[productId];
                }
            } catch (error) {
                
            }
        }

        const allScripts = document.querySelectorAll('script');
        for (let script of allScripts) {
            if (script.textContent.includes(`window.cartAddonVariants[${productId}]`)) {
                try {
                    eval(script.textContent);
                    if (window.cartAddonVariants?.[productId]) {
                        return window.cartAddonVariants[productId];
                    }
                } catch (error) {
                    
                }
            }
        }

        const optionNames = [];
        const selects = productContainer.querySelectorAll('.eam-cc-addon-variant-select');
        selects.forEach(select => {
            const optionName = select.dataset.optionName;
            if (optionName && !optionNames.includes(optionName)) {
                optionNames.push(optionName);
            }
        });

        if (optionNames.length > 0) {
            return {
                options: optionNames,
                variants: []
            };
        }

        return null;
    }
}

customElements.define('cart-addon-products', CartAddonProducts);